import { BaseNomenclatorModel} from './base.model';

export class EnzymesModel extends BaseNomenclatorModel{
    id: number;
    name: string;
    uid: string;
}
